var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('library-header'),(_vm.displayBanner)?_c('library-banner'):_vm._e(),_c('section',{staticClass:"library-content",class:{'has-side-bar': _vm.displaySidebar }},[(_vm.displaySidebar)?_c('aside',{staticClass:"content-approval-sidebar"},[_c('library-sidebar')],1):_vm._e(),_c('filter-bar'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }